{
  "logo-generator": [
    "create a logo",
    "design a logo",
    "make a logo",
    "logo for my",
    "brand logo",
    "startup logo"
  ],
  "svg-generator": [
    "make an svg",
    "create an svg",
    "generate an svg",
    "draw an svg",
    "svg icon",
    "svg illustration",
    "vector icon",
    "vector illustration",
    "text to svg"
  ],
  "email-writer": [
    "write an email",
    "write a email",
    "draft an email",
    "cold email",
    "follow up email",
    "professional email",
    "email subject line"
  ],
  "linkedin-post-generator": [
    "social media post",
    "write a post for",
    "social media caption",
    "linkedin post",
    "post for linkedin",
    "write a linkedin",
    "instagram post",
    "x post",
    "tweet",
    "threads post",
    "facebook post"
  ],
  "social-media-kit": [
    "social media post",
    "social media kit",
    "instagram caption",
    "twitter thread",
    "multi platform post"
  ],
  "product-description": [
    "product description",
    "amazon listing",
    "shopify description",
    "ecommerce copy",
    "product page copy"
  ],
  "resume-writer": [
    "write a resume",
    "write my resume",
    "fix my resume",
    "update my resume",
    "cover letter",
    "job application",
    "cv writer",
    "resume bullets"
  ],
  "text-humanizer": [
    "humanize text",
    "humanize this",
    "sound more natural",
    "remove ai tone",
    "make it sound human",
    "ai generated text",
    "robotic writing"
  ],
  "transcription": [
    "transcribe audio",
    "transcribe this",
    "audio to text",
    "speech to text",
    "convert audio"
  ],
  "image-to-text": [
    "extract text from image",
    "ocr this image",
    "read text in image",
    "scan text from photo",
    "convert image to text"
  ],
  "image-generator": [
    "make an image",
    "create an image",
    "generate an image",
    "make a picture",
    "create a picture",
    "generate a picture",
    "draw an image",
    "ai art",
    "text to image",
    "image from text",
    "create art"
  ],
  "url-analyzer": [
    "analyze this url",
    "summarize this website",
    "analyze this page",
    "scrape this url"
  ],
  "sql-generator": [
    "write sql",
    "generate sql",
    "sql query for",
    "postgres query",
    "database query"
  ],
  "regex-builder": [
    "write a regex",
    "regular expression",
    "regex pattern",
    "match this string"
  ],
  "api-builder": [
    "api request",
    "rest api call",
    "curl command",
    "http request builder"
  ],
  "app-builder": [
    "app blueprint",
    "app architecture",
    "build an app plan",
    "software spec"
  ],
  "meeting-notes": [
    "meeting notes",
    "summarize meeting",
    "meeting summary",
    "action items from meeting"
  ],
  "data-analyzer": [
    "analyze data",
    "analyze this dataset",
    "data analysis",
    "find trends in data"
  ],
  "document-reviewer": [
    "review this document",
    "proofread document",
    "document feedback",
    "review my draft"
  ],
  "presentation-outline": [
    "presentation outline",
    "slide deck outline",
    "powerpoint outline",
    "pitch deck outline"
  ],
  "interior-design": [
    "interior design",
    "room redesign",
    "decorate my room",
    "home design ideas"
  ],
  "photo-studio": [
    "edit photo",
    "photo enhancement",
    "professional headshot",
    "retouch photo"
  ],
  "video-generator": [
    "make a video",
    "create a video",
    "generate a video",
    "text to video",
    "video from text",
    "ai video",
    "cinematic video",
    "video clip"
  ],
  "clothes-changer": [
    "change clothes",
    "virtual try on",
    "outfit swap",
    "change outfit"
  ],
  "image-vectorizer": [
    "vectorize this",
    "vectorize the",
    "vectorize my",
    "vectorize a",
    "vectorize it",
    "convert to svg",
    "convert to vector",
    "image to svg",
    "png to svg",
    "jpg to svg",
    "raster to vector",
    "vector version",
    "svg file"
  ],
  "talking-photo": [
    "talking photo",
    "animate photo",
    "make photo talk",
    "photo to video face"
  ],
  "lipsync-generator": [
    "lip sync",
    "lipsync video",
    "sync lips to audio",
    "mouth sync"
  ],
  "music-generator": [
    "make a song",
    "create a song",
    "write a song",
    "compose a song",
    "make music",
    "create music",
    "generate music",
    "write music",
    "song about",
    "make a beat",
    "create a beat",
    "text to music",
    "ai song"
  ],
  "blog-writer": [
    "write a blog",
    "write a blog post",
    "blog post about",
    "blog article about",
    "seo blog post",
    "article about"
  ],
  "code-generator": [
    "write code",
    "generate code",
    "write python",
    "write javascript",
    "code for",
    "programming help",
    "implement a function",
    "build an api",
    "debug this code"
  ],
  "text-to-3d": [
    "create a 3d model",
    "make a 3d model",
    "text to 3d",
    "generate 3d model",
    "3d model of",
    "create 3d",
    "make 3d"
  ],
  "object-remover": [
    "remove object",
    "remove person from",
    "remove the person from",
    "remove background",
    "erase object",
    "remove from photo",
    "photo cleanup",
    "remove unwanted"
  ],
  "image-editor": [
    "edit this image",
    "edit my photo",
    "change background",
    "retouch photo",
    "modify image",
    "edit image",
    "edit photo"
  ],
  "image-upscaler": [
    "upscale image",
    "upscale this image",
    "upscale this photo",
    "increase resolution",
    "make image sharper",
    "enhance photo quality",
    "4k upscale",
    "super resolution"
  ],
  "translator": [
    "translate to",
    "translate this",
    "translate from",
    "in spanish",
    "in french",
    "language translation",
    "translate into"
  ],
  "text-to-speech": [
    "text to speech",
    "read aloud",
    "read this aloud",
    "read this text aloud",
    "read text aloud",
    "voiceover",
    "narration",
    "convert text to audio",
    "speak this text",
    "text to voice"
  ],
  "research-assistant": [
    "research this",
    "research about",
    "deep dive on",
    "investigate this",
    "find sources on",
    "literature review",
    "research topic"
  ]
}
